/*
 * Fairyglim Charm Bar auf der Produktseite. Gleiche Auswahl wie der Baukasten der Startseite: Kategorien, Kacheln mit Lupe,
 * Anfangsbuchstabe zum Antippen, erster Charm gratis. Hängt sich an das Kaufformular des Produkts:
 *  - Modus "property": Der erste Charm reist als Eigenschaft "Charm-Wunsch (gratis)" an der Klammer mit, jeder weitere
 *    kommt als eigene Zeile in den Warenkorb.
 *  - Modus "discount": Alle Charms sind eigene Zeilen, der automatische Rabatt "1. Charm gratis" rechnet im Warenkorb.
 * Ketten-Charms (Kollektion CHARM KETTEN, Feld k) sind nie der Gratis-Charm: Sie zeigen immer ihren Preis und kommen immer als eigene Zeile.
 * Reihenfolge der Reiter: Theme-Einstellung "Reihenfolge der Reiter" (Theme-Einstellungen > Fairyglim Charm Bar). Diese Datei ist eine Liquid-Datei, damit sie die Einstellung lesen kann.
 * Die Notiz "Wo soll welcher Charm befestigt werden?" bleibt das vorhandene Feld der Produktoptionen und reist mit.
 */
(function () {
  var root = document.querySelector('[data-fgh-charmbar]');
  var dataEl = root && root.querySelector('[data-fgh-data]');
  if (!root || !dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var MODE = root.getAttribute('data-mode') === 'discount' ? 'discount' : 'property';
  var SHOW_PRICES = root.getAttribute('data-prices') === 'true';
  var money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: root.getAttribute('data-currency') || 'EUR' });
  function eur(c) { return money.format(c / 100); }
  function q(s) { return root.querySelector(s); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var KNOWN = { 'gruppe-favorites': 'Favorites', 'gruppe-ocean-vibe': 'Ocean Vibe', 'gruppe-aesthetik': 'Aesthetic', 'gruppe-fun-food': 'Sweet Treats', 'gruppe-nazar': 'Nazar', 'gruppe-ketten': 'Ketten' };
  var LETTERS = 'Buchstaben';
  var COLORS = { Rosa: '#f1b9c4', 'Weiß': '#ffffff', Schwarz: '#2b1f24', Lila: '#b9a3e0', Rot: '#e7a0a0' };
  function colorOf(t) {
    t = t.toLowerCase();
    if (t.indexOf('schwarz') > -1) return 'Schwarz';
    if (t.indexOf('rosa') > -1) return 'Rosa';
    if (t.indexOf('weiß') > -1 || t.indexOf('weiss') > -1) return 'Weiß';
    if (t.indexOf('lila') > -1) return 'Lila';
    if (t.indexOf('rot') > -1) return 'Rot';
    return null;
  }
  function titleCase(s) { return s.split(' ').map(function (w) { return w.length <= 2 ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }).join(' '); }
  function cleanName(t) { return titleCase(t.replace(/charms?/gi, '').replace(/\|/g, '').replace(/\s+/g, ' ').trim()); }
  function labelOfTag(tag) { return tag.replace('gruppe-', '').split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' '); }

  var cats = {}, order = [], letterMap = {};
  data.charms.forEach(function (c) {
    var name = cleanName(c.t);
    var label = c.multi ? name + ' – ' + c.v.split('/').pop().trim() : name;
    var item = { key: String(c.id), id: c.id, label: label, img: c.img, big: c.big || c.img, p: c.p, chain: !!c.k };
    if (c.L && c.multi) {
      var col = colorOf(c.t);
      if (col) {
        var ch = c.v.split('/').pop().trim().toUpperCase();
        (letterMap[col] = letterMap[col] || {})[ch] = item;
        item.letter = { ch: ch, col: col };
        item.label = 'Buchstabe ' + col + ' – ' + ch;
        return;
      }
    }
    var groups = c.g ? c.g.split(',').filter(Boolean) : [];
    var names = groups.length ? groups.map(function (g) { return KNOWN[g] || labelOfTag(g); }) : ['Sonstiges'];
    names.forEach(function (n) { if (!cats[n]) { cats[n] = []; order.push(n); } cats[n].push(item); });
  });
  var knownOrder = String("Favorites, Aesthetic, Ketten, Sweet Treats, Nazar, Ocean Vibe").split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  order.sort(function (a, b) {
    if (a === 'Sonstiges') return 1;
    if (b === 'Sonstiges') return -1;
    var ia = knownOrder.indexOf(a.toLowerCase()), ib = knownOrder.indexOf(b.toLowerCase());
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
  });
  if (Object.keys(letterMap).length) order.splice(Math.min(3, order.length), 0, LETTERS);

  var state = { cat: order[0], color: Object.keys(letterMap)[0] || 'Rosa', sel: [] };
  var elCats = q('[data-cats]'), elCharms = q('[data-charms]'), elSel = q('[data-sel]'), elSelWrap = q('[data-sel-wrap]'), elSum = q('[data-sum]');
  var ZOOM_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5M11 8.5v5M8.5 11h5"/></svg>';

  /* Der Gratis-Charm ist der erste gewählte Charm, der keine Kette ist. */
  function freeIdx() {
    for (var i = 0; i < state.sel.length; i++) { if (!state.sel[i].chain) return i; }
    return -1;
  }

  function renderCats() {
    elCats.innerHTML = '';
    order.forEach(function (c) {
      var b = el('button', null, esc(c === LETTERS ? 'Buchstaben' : c));
      b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', c === state.cat);
      b.onclick = function () { state.cat = c; renderCats(); renderCharms(); };
      elCats.appendChild(b);
    });
  }
  function toggle(item) {
    var i = state.sel.findIndex(function (s) { return s.key === item.key; });
    if (i > -1) state.sel.splice(i, 1); else state.sel.push(item);
    renderCharms(); render();
  }
  function renderCharms() {
    elCharms.innerHTML = '';
    if (state.cat === LETTERS) { renderLetters(); return; }
    var fi = freeIdx();
    (cats[state.cat] || []).forEach(function (item) {
      var idx = state.sel.findIndex(function (s) { return s.key === item.key; });
      var isFree = idx > -1 && idx === fi;
      var chip = el('button', 'fgh-chip', (item.img ? '<span class="fgh-thumb"><img src="' + esc(item.img) + '" alt="" loading="lazy"><span class="fgh-zoom" role="button" tabindex="0" aria-label="' + esc(item.label) + ' vergrößern" data-zoom="' + esc(item.big) + '" data-alt="' + esc(item.label) + '">' + ZOOM_SVG + '</span></span>' : '') + '<span>' + esc(item.label) + (item.chain ? '<span class="fgh-chip-pr">+ ' + esc(eur(item.p)) + '</span>' : '') + '</span><i class="fgh-badge' + (isFree ? ' fgh-badge--free' : '') + '">' + (isFree ? 'gratis' : (idx + 1)) + '</i>');
      chip.type = 'button';
      chip.setAttribute('aria-pressed', idx > -1);
      chip.onclick = function () { toggle(item); };
      elCharms.appendChild(chip);
    });
  }
  function pickLetter(it, keep) {
    if (!it) return;
    var cur = state.sel.findIndex(function (x) { return x.letter; });
    var same = cur > -1 && state.sel[cur].id === it.id;
    if (cur > -1) state.sel.splice(cur, 1);
    if (!same || keep) state.sel.push({ key: 'L' + it.id, id: it.id, label: it.label, img: '', p: it.p, letter: it.letter });
  }
  function renderLetters() {
    var wrap = el('div', 'fgh-letters');
    var sw = el('div', 'fgh-swatches'); sw.setAttribute('role', 'group'); sw.setAttribute('aria-label', 'Farbe');
    Object.keys(letterMap).forEach(function (c) {
      var s = el('button', 'fgh-swatch'); s.type = 'button'; s.style.background = COLORS[c] || '#ddd'; s.title = c;
      s.setAttribute('aria-label', c); s.setAttribute('aria-pressed', c === state.color);
      s.onclick = function () {
        var cur = state.sel.find(function (x) { return x.letter; });
        state.color = c;
        state.sel = state.sel.filter(function (x) { return !x.letter; });
        if (cur && letterMap[c] && letterMap[c][cur.letter.ch]) pickLetter(letterMap[c][cur.letter.ch], true);
        renderCharms(); render();
      };
      sw.appendChild(s);
    });
    var grid = el('div', 'fgh-letter-grid'); grid.setAttribute('role', 'group'); grid.setAttribute('aria-label', 'Buchstabe');
    var map = letterMap[state.color] || {};
    var chosen = state.sel.find(function (x) { return x.letter; });
    var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    ['Ä', 'Ö', 'Ü'].forEach(function (u) { if (map[u]) alphabet.push(u); });
    alphabet.forEach(function (ch) {
      var it = map[ch];
      var bt = el('button', 'fgh-letter', esc(ch));
      bt.type = 'button';
      bt.style.background = COLORS[state.color] || '#fff';
      bt.style.color = state.color === 'Schwarz' ? '#fff' : '#2b1f24';
      if (!it) { bt.disabled = true; bt.title = ch + ' ist in ' + state.color + ' gerade nicht vorrätig'; }
      bt.setAttribute('aria-pressed', !!(chosen && chosen.letter.ch === ch));
      bt.onclick = function () { pickLetter(it); renderCharms(); render(); };
      grid.appendChild(bt);
    });
    var miss = alphabet.filter(function (ch) { return !map[ch]; });
    wrap.appendChild(el('p', 'fgh-letters__title', 'Wähle deinen Anfangsbuchstaben und die Farbe.'));
    wrap.appendChild(sw); wrap.appendChild(grid);
    if (miss.length) wrap.appendChild(el('p', 'fgh-letters__hint', 'In ' + esc(state.color) + ' gerade nicht vorrätig: ' + esc(miss.join(', ')) + '.'));
    elCharms.appendChild(wrap);
  }

  function totals() {
    var sum = state.sel.reduce(function (a, s) { return a + s.p; }, 0);
    var fi = freeIdx();
    var free = 0;
    if (fi > -1) {
      free = MODE === 'property' ? state.sel[fi].p : Math.min.apply(null, state.sel.filter(function (s) { return !s.chain; }).map(function (s) { return s.p; }));
    }
    var chains = state.sel.reduce(function (a, s) { return a + (s.chain ? s.p : 0); }, 0);
    return { extra: sum - free, free: free, chains: chains };
  }
  function render() {
    var n = state.sel.length, t = totals(), fi = freeIdx();
    elSelWrap.hidden = !n;
    elSel.innerHTML = '';
    state.sel.forEach(function (s, k) {
      var li = el('li');
      li.innerHTML = (s.img ? '<img src="' + esc(s.img) + '" alt="">' : '<span class="fgh-mini" style="background:' + (COLORS[s.letter.col] || '#fff') + ';color:' + (s.letter.col === 'Schwarz' ? '#fff' : '#2b1f24') + '">' + esc(s.letter.ch) + '</span>') +
        '<span class="nm">' + esc(s.label) + '</span><span class="pr' + (k === fi ? ' free' : '') + '">' + (k === fi ? 'gratis' : ((SHOW_PRICES || s.chain) ? eur(s.p) : '')) + '</span><button type="button" aria-label="' + esc(s.label) + ' entfernen">×</button>';
      li.querySelector('button').onclick = function () { state.sel.splice(k, 1); renderCharms(); render(); };
      elSel.appendChild(li);
    });
    var msg = '';
    if (n) {
      if (t.extra > 0) {
        msg = SHOW_PRICES ? 'Aufpreis für Charms: <b>+ ' + eur(t.extra) + '</b>' : (t.chains > 0 ? 'Aufpreis für Ketten-Charms: <b>+ ' + eur(t.chains) + '</b>. Den Gesamtpreis siehst du im Warenkorb.' : 'Den Gesamtpreis siehst du im Warenkorb.');
      } else {
        msg = 'Dein erster Charm ist <b>gratis</b>.';
      }
    }
    elSum.innerHTML = msg;
    syncForm();
  }

  /* ---------- Kaufformular ---------- */
  var form = (root.closest('.product__info-container') || document).querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
  var submitBtn = form && form.querySelector('button[type="submit"][name="add"]');
  var dyn = form && form.querySelector('.shopify-payment-button');
  var elExpress = q('[data-express]');
  var propInput = null;
  var noteField = q('[data-note]');
  if (form && noteField) { noteField.name = 'properties[Charm-Platzierung]'; var formId = form.getAttribute('id'); if (formId) noteField.setAttribute('form', formId); }
  if (form) {
    propInput = document.createElement('input');
    propInput.type = 'hidden'; propInput.name = 'properties[Charm-Wunsch (gratis)]'; propInput.disabled = true;
    form.appendChild(propInput);
    if (dyn && elExpress) dyn.insertAdjacentElement('afterend', elExpress);
  }
  /* Ohne Zusatzzeilen reicht das normale Formular: nur im Modus "property" mit genau einem Charm, der keine Kette ist. */
  function needsIntercept() {
    if (MODE === 'discount') return state.sel.length >= 1;
    return state.sel.length > 1 || (state.sel.length === 1 && state.sel[0].chain);
  }
  function syncForm() {
    if (!propInput) return;
    if (MODE === 'property' && state.sel.length === 1 && !state.sel[0].chain) { propInput.value = state.sel[0].label; propInput.disabled = false; }
    else { propInput.value = ''; propInput.disabled = true; }
    var hide = needsIntercept();
    if (dyn) dyn.style.display = hide ? 'none' : '';
    if (elExpress) elExpress.hidden = !hide;
  }

  if (form) {
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('button[type="submit"][name="add"]');
      if (!btn || !form.contains(btn) || !needsIntercept()) return;
      e.preventDefault(); e.stopPropagation();
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!idInput || !idInput.value) return;
      var props = {};
      state.sel.length && (props['Charms'] = state.sel.map(function (s) { return s.label; }).join(', '));
      var noteEl = q('[data-note]'); var noteVal = noteEl ? noteEl.value.trim() : '';
      if (noteVal) props['Charm-Platzierung'] = noteVal;
      var fi = freeIdx();
      if (MODE === 'property' && fi > -1) props['Charm-Wunsch (gratis)'] = state.sel[fi].label;
      document.querySelectorAll('.gpo-app input, .gpo-app textarea, .gpo-app select').forEach(function (f) {
        if (!f.name || f.disabled) return;
        if ((f.type === 'checkbox' || f.type === 'radio') && !f.checked) return;
        props[f.name] = f.value || '';
      });
      var items = [{ id: idInput.value, quantity: parseInt(qtyInput && qtyInput.value, 10) || 1, properties: props }];
      var counts = {}, seq = [];
      state.sel.forEach(function (s, k) {
        if (MODE === 'property' && k === fi) return;
        if (!(s.id in counts)) { counts[s.id] = 0; seq.push(s.id); }
        counts[s.id] += 1;
      });
      seq.forEach(function (id) { items.push({ id: id, quantity: counts[id] }); });
      if (submitBtn) submitBtn.disabled = true;
      var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items };
      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j && j.description || 'add failed'); return j; }); })
        .then(function (j) {
          if (cartEl && j.sections && typeof cartEl.getSectionsToRender === 'function') {
            cartEl.getSectionsToRender().forEach(function (s) {
              var html = j.sections[s.id]; if (!html) return;
              var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector || '.shopify-section');
              var target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
              if (parsed && target) target.innerHTML = parsed.innerHTML;
            });
            if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
          }
          if (cartEl && typeof cartEl.open === 'function') cartEl.open();
          if (submitBtn) submitBtn.disabled = false;
        })
        .catch(function () {
          if (submitBtn) submitBtn.disabled = false;
          window.alert('Beim Hinzufügen zum Warenkorb ist etwas schiefgelaufen. Bitte versuche es noch einmal.');
        });
    }, true);
  }

  /* ---------- Vergrößern ---------- */
  var box = q('[data-lightbox]'), boxImg = q('[data-lightbox-img]');
  function openZoom(src, alt) { if (!box || !src) return; boxImg.src = src; boxImg.alt = alt || ''; box.hidden = false; var c = box.querySelector('[data-lightbox-close]'); if (c) c.focus(); }
  function closeZoom() { if (!box) return; box.hidden = true; boxImg.src = ''; }
  root.addEventListener('click', function (e) {
    var z = e.target.closest('.fgh-zoom[data-zoom]');
    if (z && root.contains(z)) { e.preventDefault(); e.stopPropagation(); openZoom(z.getAttribute('data-zoom'), z.getAttribute('data-alt')); }
  }, true);
  root.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.fgh-zoom[data-zoom]')) { e.preventDefault(); openZoom(e.target.getAttribute('data-zoom'), e.target.getAttribute('data-alt')); }
  });
  if (box) box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('[data-lightbox-close]')) closeZoom(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box && !box.hidden) closeZoom(); });

  /* Die Produktoptionen-App zeigt dieselbe Frage ("Charm-Platzierung"): Hier übernimmt sie die Charm Bar. Feld ausblenden und abschalten. */
  function retireOldNote() {
    document.querySelectorAll('gpo-container input, gpo-container textarea, gpo-container select').forEach(function (f) { f.disabled = true; });
  }
  retireOldNote();
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () { retireOldNote(); });
    var gc = document.querySelector('.product-form__buttons') || document.body;
    mo.observe(gc, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 8000);
  }

  renderCats(); renderCharms(); render();
})();
